import React, { Component } from 'react'
import OLDraw from 'ol/interaction/draw';
import ol_condition from 'ol/events/condition';
import { drawCursorStyles } from '../../../mapStyles';

class Draw extends Component {
  constructor(props) {
    super(props)

    this.draw = new OLDraw({
      condition: ol_condition.platformModifierKeyOnly,
      type: 'Polygon',
      style: drawCursorStyles,
    })
    this.draw.on('drawend', props.onDrawEnd);
    props.mapInstance.addInteraction(this.draw);
  }

  componentDidMount() {

  }

  componentWillUnmount() {
    this.props.mapInstance.removeInteraction(this.draw);
  }

  render() {
    return null;
  }
}

export default Draw;



// WEBPACK FOOTER //
// ./src/components/ol/interactions/Draw.js